<template>
    <div class="">
        <div class="list">
            <div @click="row_click(item.ID)" class="list-item" v-for="(item, index) in project_list" :key="index">
                <div style="max-width: 200px;" class="center_box">
                    <div class="icon-doc"></div>
                    {{ item.TITLE }}
                </div>

                <div class="setting center_box">

                    <div v-if="item.IS_NEED == 1 && item.STATUS" class="info">保证金：<span>{{ item.MONEY }}</span>
                        元；未中标自动退。
                    </div>

                    <div v-if="item.IS_NEED == 1 && item.STATUS" :style="index == 1 ? 'color:#333' : 'color:#999'"
                        class="is_jiao_na">
                        {{ index == 1 ? '已缴纳' : '未缴纳' }}
                    </div>
                    <div v-if="item.STATUS" :class="handleStyle(is_status(item.STATUS))" class="tab">{{ item.STATUS_TXT
                    }}</div>

                    <el-button @click="handleClick()" type="primary"
                        style="width:38px ;height: 27px;display: flex;align-items: center;justify-content: center;"
                        size="mini">查看</el-button>
                    <div class="time">
                        发布时间 {{ item.PUBLISH_TIME_TXT }}
                    </div>
                </div>
            </div>
            <el-empty v-if="project_list.length == 0" description="暂无数据..."></el-empty>
        </div>

        <!-- 分页 -->
        <div class="boxc">
            <el-pagination @current-change="current_change" :current-page="page" :total="total" :page-size="limit"
                class="custom-pagination" background layout="prev, pager, next">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    name: 'wd_jb',
    mixins: [],
    props: {},
    data() {
        return {
            project_list: [],
            isDetail: true,
            join_type: 0,
            page: 1,
            limit: 10,
            total: 0,
        }
    },
    methods: {
        current_change(page) {
            // 更新查询参数中的页码
            this.query.page = page;
            // 重新获取列表数据
            this.get_table_list()

        },
        row_click(row) {
            this.$emit("row_click", row)
            // console.log(row, '----->');
            // // 将项目ID存入localStorage，供其他页面或组件使用
            // localStorage.setItem('get_info_id', row);
            // // 使用 $nextTick 确保DOM更新后再触发事件
            // this.$nextTick(() => {
            //     // 向父组件或其他监听者发送 'handleClick' 事件
            //     // 参数: 1 (标识操作类型), '12' (标识具体场景或来源), row (行数据)
            //     this.$emit('handleClick', 1, '12', row);
            // });
        },
        handleClick() {
            this.isDetail = false
        },
        async get_table_list() {
            const res = await this.$http.post('/api/user/project_bid', {
                join_type: this.join_type,
                page: this.page,
                limit: this.limit,
            })
            this.total = res.data.data.total; // 更新总条数
            this.project_list = res.data.data.data
            console.log(this.project_list, 'this.project_list');
        },
    },
    created() { },
    mounted() {
        this.get_table_list()
    },
    computed: {
        is_status() {
            // 使用闭包返回一个可以访问 this.detail_data 的函数
            return function (e) {
                console.log(e, 'eeeee----->');
                // 这里保持原写法，但需注意潜在问题
                let status = e; // 获取原始状态码
                let step = 0; // 初始化步骤编号
                // 状态映射逻辑
                if (status == 4) { // 竞价中 -> 映射到第 3 步 (竞价)
                    step = 3;
                } else if (status == 5 || status == 6) { // 待开标/已开标? -> 映射到第 4 步 (开标)
                    step = 4;
                } else if (status == 7) { // 已公示? -> 映射到第 5 步 (假设有公示步骤)
                    step = 5;
                } else { // 其他状态 (1:报名, 2:待审核?, 3:待竞价?) 直接使用
                    step = Number(status); // 确保是数字
                }
                return step; // 返回映射后的步骤编号
            }
        },
        handleStyle() {
            return function (e) {
                const styles = [
                    'tag_style1', // 0
                    'tag_style1', // 1
                    'tag_style2', // 2
                    'tag_style3', // 3
                    'tag_style4', // 4
                    'tag_style5', // 5
                    'tag_style6', // 6
                    'tag_style7'  // 7
                ];
                return styles[e] || ''; // 如果 e 超出范围，返回空字符串
            }
        }
    },
    watch: {},
}
</script>

<style scoped lang="scss">
.list {
    min-height: 590px;

    .list-item {
        padding: 15px 0;
        display: flex;
        align-items: center;
        cursor: pointer;
        justify-content: space-between;

        .icon-doc {
            width: 10px;
            height: 10px;
            background: #EDEEF1;
            margin: 0 10px 0 10px;
            border-radius: 20px;
        }

        &:hover {
            color: #c8102e;
        }

        .setting {
            width: 76%;
            display: flex;
            justify-content: space-evenly;

            .info {
                font-size: 14px;
                color: #666666;
            }

            .is_jiao_na {
                font-size: 14px;
                color: #333333;
            }

            .time {
                font-size: 14px;
                color: #999999;
            }

            .tab {
                font-size: 14px;
                padding: 2px 6px;
                box-sizing: border-box;
                border-radius: 2px;
            }

            .tag_style0 {
                border: 2px solid #6193ED;
                background-color: #eff4fd;
                color: #6193ED;
            }

            .tag_style1 {
                border: 2px solid #3CB532;
                background-color: #f5fbe7;
                color: #3CB532;
            }

            .tag_style2 {
                border: 2px solid #FFA100;
                background-color: #fff5e5;
                color: #FFA100;
            }

            .tag_style3 {
                border: 2px solid #C28EE1;
                background-color: #f6effa;
                color: #C28EE1;
            }

            .tag_style4 {
                color: #C31424;
            }

            .tag_style5 {
                color: #0256FF;

            }

            .tag_style6 {
                border: 2px solid #999999;
                background-color: #f3f3f3;
                color: #999999;
            }

            .tag_style7 {
                border: 2px solid #a40404;
                background-color: #c31424;
                color: #fff;
            }
        }
    }
}
</style>